












import { Component, Vue, Prop } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";  
@Component({
  components: {
    DsEditor,
  },
})
export default class ReportFengmian extends Vue {
  @Prop()
  private config: any;
}
